import { Dropdown } from 'antd';
import { useTranslation } from 'next-i18next';
import { useCallback, useEffect } from 'react';

import styles from './index.module.scss';
import bookIcon from '../../../assets/Home/book.svg';
import communicationGroupIcon from '../../../assets/Home/communicationGroup.svg';
import reportIcon from '../../../assets/Home/report.svg';
import { getUserInfo, useAppDispatch, useAppSelector } from '../../../state';
import { track } from '../../../track';
import { isTalkie } from '../../../utils';
import { LocalImage } from '../../Image';
interface IHomeHeaderProps {
  groupDropDown: React.ReactNode;
  handleClickFeedback: () => void;
  createBookUrl: string;
  handleSignOut: () => void;
  logoIcon: string;
  defaultAvatarImage: string;
  source: string;
}

export function HomeHeader({
  groupDropDown,
  handleClickFeedback,
  createBookUrl,
  handleSignOut,
  logoIcon,
  defaultAvatarImage,
  source,
}: IHomeHeaderProps) {
  const { t } = useTranslation();
  const { userProfile } = useAppSelector((state) => state.user);

  const onClickItem = useCallback((item: string) => {
    track.send('quick_entrance_click', source, {
      quick_entrance_btn_type: item,
    });
  }, []);

  const { appSettings } = useAppSelector((state) => state.global);

  return (
    <header className={styles.headerContainer}>
      <div className={styles.headerLeft}>
        <LocalImage
          className={styles.logo}
          src={logoIcon}
          alt="home logo"
          onClick={() => (location.href = '/')}
        />
        <div className={styles.divider} />
        <p className={styles.headerTitle} onClick={() => (location.href = '/create')}>
          {t('homeTitle')}
        </p>
      </div>
      <div className={styles.headerRight}>
        {!isTalkie && (
          <Dropdown autoAdjustOverflow dropdownRender={() => groupDropDown} placement="bottomRight">
            <div className="text-[14px] px-[12px] py-[8px] text-[#ffffffb2] bg-[#ffffff0f] rounded-[8px] flex justify-center items-center gap-[4px] font-[500] cursor-pointer hover:bg-[#ffffff1a]">
              <LocalImage src={communicationGroupIcon} alt="communicate" width={18} height={18} />
              <span>{t('communicationGroup')}</span>
            </div>
          </Dropdown>
        )}
        <div
          className="text-[14px] px-[12px] py-[8px] text-[#ffffffb2] bg-[#ffffff0f] rounded-[8px] flex justify-center items-center gap-[4px] font-[500] cursor-pointer hover:bg-[#ffffff1a]"
          onClick={() => {
            onClickItem('feedback');
            handleClickFeedback();
          }}
        >
          <LocalImage src={reportIcon} alt="report" width={18} height={18} />
          <span>{t('feedbackEntry')}</span>
        </div>
        {!!appSettings?.web_ugc_create_book_url && (
          <div
            className="text-[14px] px-[12px] py-[8px] text-[#ffffffb2] bg-[#ffffff0f] rounded-[8px] flex justify-center items-center gap-[4px] font-[500] cursor-pointer hover:bg-[#ffffff1a]"
            onClick={() => {
              onClickItem('create_manual');
              window.open(appSettings.web_ugc_create_book_url, '_blank');
            }}
          >
            <LocalImage src={bookIcon} alt="create book" width={18} height={18} />
            <span>{t('createBook')}</span>
          </div>
        )}
        <Dropdown
          autoAdjustOverflow
          className="flex justify-center items-center rounded-full border-[#ffffff26] border-solid border-[0.5px] w-[48px] h-[48px] overflow-hidden p-[2px] box-border"
          dropdownRender={() => (
            <div className="flex w-[232px] p-[8px] flex-col items-start gap-[12px] rounded-[12px] bg-[#1c1d20]">
              <div className="flex items-center gap-[8px] w-full">
                <LocalImage
                  src={userProfile.avatarUrl || defaultAvatarImage}
                  alt="avatar"
                  width={48}
                  height={48}
                  className="rounded-full"
                />
                <div className="flex flex-col flex-1 min-w-0">
                  <div className="text-[#ffffffe5] font-[600] text-[16px] truncate">
                    {userProfile.nickname}
                  </div>
                  <div className="truncate">UID: {userProfile.uniqueId}</div>
                </div>
              </div>
              <div
                className="self-stretch flex p-[10px] justify-center items-center gap-[10px] rounded-[8px] bg-[#ffffff0f] cursor-pointer hover:bg-[#ffffff1a]"
                onClick={handleSignOut}
              >
                {t('signOut')}
              </div>
            </div>
          )}
        >
          <LocalImage
            src={userProfile.avatarUrl || defaultAvatarImage}
            alt="user avatar"
            width={44}
            height={44}
            className="rounded-full"
          />
        </Dropdown>
      </div>
    </header>
  );
}
